export default __webpack_public_path__ + "static/media/valid.d4def3cf.svg";